import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseSkeleton = _resolveComponent("BaseSkeleton")!
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_ctx.isLoading)
    ? (_openBlock(), _createBlock(_component_BaseSkeleton, _mergeProps({
        key: 0,
        type: _ctx.skeleton ? _ctx.skeleton : 'avatar',
        class: _ctx.classes
      }, _ctx.$attrs), null, 16, ["type", "class"]))
    : (_openBlock(), _createBlock(_component_v_icon, _mergeProps({
        key: 1,
        class: ["base-icon", _ctx.classes]
      }, _ctx.$attrs), {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$attrs.name), 1)
        ]),
        _: 1
      }, 16, ["class"]))
}